/* eslint-disable react-refresh/only-export-components */
import {
  createContext,
  ReactNode,
  useCallback,
  useContext,
  useState,
} from 'react';

interface HeaderContextValue {
  mobileActionButton: ReactNode | null;
  setMobileActionButton: (button: ReactNode | null) => void;
}

const HeaderContext = createContext<HeaderContextValue | undefined>(undefined);

export interface HeaderProviderProps {
  children: ReactNode;
}

export function HeaderProvider({ children }: HeaderProviderProps) {
  const [mobileActionButton, setMobileActionButton] =
    useState<ReactNode | null>(null);

  const value = {
    mobileActionButton,
    setMobileActionButton: useCallback((button: ReactNode | null) => {
      setMobileActionButton(button);
    }, []),
  };

  return (
    <HeaderContext.Provider value={value}>{children}</HeaderContext.Provider>
  );
}

// Hook can be in same file since it's tightly coupled to the context
export function useHeader() {
  const context = useContext(HeaderContext);

  if (context === undefined) {
    throw new Error('useHeader must be used within a HeaderProvider');
  }

  return context;
}
